import { TriangleAlert } from "lucide-react";

export default function Disclaimer() {
  return (
    <div data-testid="disclaimer-page" className="min-h-screen">
      <section className="bg-[#facc15] border-b-[3px] border-black">
        <div className="max-w-5xl mx-auto px-4 md:px-8 py-14 flex items-start gap-5">
          <TriangleAlert className="w-10 h-10 shrink-0" strokeWidth={3} />
          <div>
            <div className="font-mono-ui text-xs">— IMPORTANT NOTICE</div>
            <h1 className="font-display text-4xl md:text-5xl leading-none mt-3">For Research Use Only</h1>
          </div>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 md:px-8 py-14 space-y-6 text-base leading-relaxed text-black/85">
        <p>
          All products listed and sold by UK Peptide Research Ltd (&ldquo;UKPR&rdquo;) are supplied
          strictly for in-vitro laboratory research purposes. They are not drugs, foods,
          cosmetics or dietary supplements and are not intended for use in or on human
          beings or animals.
        </p>
        <p className="border-l-[4px] border-[#ff1493] pl-5 font-mono-ui text-sm">
          BY PURCHASING FROM UKPR YOU CONFIRM THAT YOU ARE A QUALIFIED RESEARCHER OR
          LABORATORY PROFESSIONAL AND THAT THE PRODUCTS WILL BE USED SOLELY FOR
          LEGITIMATE IN-VITRO RESEARCH IN AN APPROPRIATE RESEARCH SETTING.
        </p>
        <h3 className="font-display text-2xl mt-10">Prohibited uses</h3>
        <ul className="list-disc pl-6 space-y-2 text-sm">
          <li>Products MUST NOT be administered to humans or animals under any circumstances.</li>
          <li>Products MUST NOT be used for diagnostic, therapeutic or cosmetic purposes.</li>
          <li>Products MUST NOT be resold for human consumption or recreational use.</li>
        </ul>
        <h3 className="font-display text-2xl mt-10">Shipping restrictions</h3>
        <p>
          UKPR currently dispatches orders to addresses within the United Kingdom only. By
          placing an order you agree to comply with all applicable local, national and
          international laws governing the import, possession and use of research chemicals.
        </p>
        <h3 className="font-display text-2xl mt-10">Liability</h3>
        <p>
          UKPR disclaims all liability for any misuse or unlawful use of its products. The
          buyer accepts full responsibility for the handling, storage and disposal of the
          products in accordance with good laboratory practice.
        </p>
      </section>
    </div>
  );
}
